<template>
  <div class="sessionBar">
    <div class="left-area" :style="transparentColor">
      <CofocusLogo :isSession="true" />
      <PartnerInfo />
    </div>
    <InSessionTimer v-if="sessionLoaded" :userID="userID" :sessionLoaded="sessionLoaded" :isCompleted="isCompleted" :timerVisible="timerVisible" />
    <!-- <TasksButton :isSession="true" /> -->
    <ChatToggle />
    <HelpToggle />
    <SettingsToggle />
    <ExitButton />
  </div>
</template>

<script>
import CofocusLogo from "../../../components/Nav/NavComponents/CofocusLogo";
import InSessionTimer from "../../../components/Timer/InSessionTimer";
// import TasksButton from "@/components/Nav/Dropdowns/TasksButton";
import ExitButton from "../Session/SessionComponents/ExitButton";
import PartnerInfo from "../Session/SessionComponents/PartnerInfo";
import SettingsToggle from "../Session/SessionComponents/SessionSettings/SettingsToggle";
import HelpToggle from "../Session/SessionComponents/SessionHelp/HelpToggle";
import ChatToggle from "../Session/SessionComponents/SessionChat/ChatToggle";

import { transparentColor } from "../Session/SessionHelpers/colors";

export default {
  name: "RoomSessionBar",
  props: {
    userID: String,
    sessionLoaded: Boolean,
    isCompleted: Boolean,
    timerVisible: Boolean,
  },
  components: {
    CofocusLogo,
    InSessionTimer,
    // TasksButton,
    ExitButton,
    PartnerInfo,
    SettingsToggle,
    HelpToggle,
    ChatToggle,
  },
  computed: {
    transparentColor() {
      return transparentColor();
    },
  },
};
</script>

<style>
.sessionBar {
  display: flex;
  align-items: center;
  padding: 0px;
  margin: 0 18px;
  width: calc(100% - 38px);
  position: absolute;
  left: 0;
  right: 0;
  top: 16px;
  z-index: 200;
}

.sessionBar .left-area {
  margin-right: auto;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 360px;
  padding: 4px 6px;
  background-color: rgb(255 255 255 / 65%);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
  height: 52px;
  box-shadow: 0 1px 4px 0 hsl(0deg 0% 69% / 40%);
}

.sessionBar .exit {
  margin-right: 0px;
  margin-left: 10px;
  display: flex;
  align-items: center;
  border-radius: 360px;
  border: 1px solid transparent;
  padding: 5px 16px;
  box-sizing: border-box;
  background-color: rgba(255, 255, 255, 0.65);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  box-shadow: 0 1px 4px 0 hsl(0deg 0% 69% / 40%);
  height: 44px;
}

.sessionBar .exit:hover {
  background-color: white;
  border: 1px solid #eaeaea;
}

.sessionBar .exit .icon {
  width: 20px;
  height: 20px;
  padding: 5px 9px;
  border-radius: 3px;
  padding-right: 0px;
  display: flex;
  justify-content: center;
}

.sessionBar .exit .text {
  font-size: 15px;
  font-weight: 600;
}
</style>
